import { ContactNoteSource, ContactNoteViewModel } from "./Note.types";

export const getNoteAuthorName = (note: ContactNoteSource): string => {
  return (
    [
      note.createdByUser?.userProfile?.firstName,
      note.createdByUser?.userProfile?.lastName,
    ]
      .filter(Boolean)
      .join(" ") ||
    [note.firstName, note.lastName].filter(Boolean).join(" ") ||
    "Unknown"
  );
};

export const getNoteAuthorColor = (
  note: ContactNoteSource,
): string | undefined => {
  return note.createdByUser?.userProfile?.color || undefined;
};

export const mapNoteToViewModel = (
  note: ContactNoteSource,
): ContactNoteViewModel => {
  const authorName = getNoteAuthorName(note);

  return {
    id: note.noteId || note.id || authorName,
    title: note.title,
    note: note.note,
    createdAt: note.createdAt,
    authorName,
    authorColor: getNoteAuthorColor(note),
    isPinned: note.isPinned,
    workId: note.workId,
    workName: note.workName,
  };
};

const NOTE_TITLE_MAX = 60;

/** Title of the "Delete note" confirmation (Roadmap 1806, Hazel's
 * "Delete '[Item Name]' [Item Type]?" format). */
export const getNoteDeleteTitle = (title?: string | null): string => {
  const clean = (title || "").replace(/\s+/g, " ").trim();
  if (!clean) return "Delete note?";
  const short =
    clean.length > NOTE_TITLE_MAX
      ? `${clean.slice(0, NOTE_TITLE_MAX - 1).trimEnd()}…`
      : clean;
  return `Delete ‘${short}’ note?`;
};

/** Profile "Notes" card (QA batch 8): the client's own notes and its work
 * items' notes (same `search-notes` list as the Notes tab), newest first. */
export const PROFILE_NOTES_MAX = 10;

export const newestNotes = <T extends { createdAt?: string | Date | null }>(
  notes: T[] | undefined | null,
  max = PROFILE_NOTES_MAX,
): T[] => {
  const time = (n: T) => {
    const t = n?.createdAt ? new Date(n.createdAt).getTime() : NaN;
    return Number.isNaN(t) ? 0 : t;
  };
  return [...(notes || [])].sort((a, b) => time(b) - time(a)).slice(0, max);
};
